/**
 *
 */
import BaseConst from "../../common/BaseConst";

export default class Const extends BaseConst {
  [key: string]: any;
  static readonly FORUM_ENDPOINT: string = '/xarticles.php?method=postMessage';
  static readonly POST_NOT_APPROVED: string = 'POST_NOT_APPROVED';
  static readonly POST_UNSUCCESSFUL: string = 'POST_UNSUCCESSFUL';
  static readonly POST_NOT_ALLOWED: string = 'POST_NOT_ALLOWED';
  static readonly STORAGE_KEY: string = 'xarticle-post';
  static readonly CLASS_ERROR: string = 'error';
  static readonly CLASS_HIDE: string = 'hide';
  static readonly CLASS_WARN: string = 'warn';
  static readonly CLASS_INFO: string = '';
  static readonly CLASS_FILL_INFO: string = 'gradient-fill-info';
  static readonly CLASS_FILL_WARN: string = 'gradient-fill-warn';
  static readonly CLASS_FILL_ERROR: string = 'gradient-fill-error';
  static readonly CLASS_TA_FOCUSED: string = 'ta-focused';
  static readonly FORM_BORDER_FOCUSED: string = 'focused';
  static readonly FORM_BORDER_DEFAULT: string = '';
  static readonly ANONYMOUS: string = '1';
  static readonly FINANCE: string = 'fi';
  static readonly FACEBOOK: string = 'fb';
  static readonly GOOGLE: string = 'gg';
  static readonly EXPIRE: number = 60 * 1000; // срок актуальности сохранённого поста (первый множитель - секунды)
  static readonly POST_MIN_LENGTH: number = 2;
  static readonly BREAKPOINT: number = 479;
  static readonly THEME_COLORS = {
    old: '#5ba79a',
    new: '#00bff1'
  };
  static readonly TEXT_AREA = {
    expanded: {
      height: 122,
      fontSize: '14px'
    },
    shrinked: {
      height: 40,
      fontSize: '16px'
    }
  }
}
